import { cn } from "@/utils/core/generalUtils";

interface LoadingProps {
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({ className }) => {
  return (
    <div
      className={cn(
        "py-24 flex flex-col items-center justify-center",
        className,
      )}
    >
      <div className='border-4 w-12 h-12 border-t-indigo-500 animate-spin rounded-full p-2'></div>
    </div>
  );
};

export default Loading;
